import React, { useState } from "react";
import { Btn } from "../../../AbstractElements";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { useGetRolesList } from "../../ProductCatalogue/NotificationRepo";
import { Use_getUserConfigStatus, useUpdateUser } from "../SuperSettingsScreen/hook/useUserManagement";


interface ReqBodyInterfce{
  Name: string,
  Email: string,
  Phone: string,
  RoleId: number,
  Status: number
}

interface rowDataInterface{
  Name: string;
  Email: string;
  Role: string;
  StatusValue:string
  LastLogin: number; 
  linked: number;
  Phone:number;
  RoleId:number,
  UserId:number
}

interface UserManagementModalContentProps {
  handleClose: () => void;
  rowData:rowDataInterface
}

interface intialformDataInterface {
  name:string,
  email:string,
  phone:number | undefined,
  Role: string | number
  StatusValue:string | number
}

const UserManagementModalContent: React.FC<UserManagementModalContentProps> = ({
  handleClose,
  rowData
}) => {
  
  
  const intiaState:intialformDataInterface={
   name:rowData?.Name,
   email:rowData?.Email,
   phone:rowData?.Phone,
   Role:rowData?.RoleId,
   StatusValue:rowData?.StatusValue ==="Inactive"? 0 : 1
  }
  const [formdata,setFormData] = useState(intiaState);
  const{data:RolesData,isLoading:RolesIsLoading,isSuccess:rolesIssuccess} = useGetRolesList({enable:true,params:{
               start:1,
               length:30,
               search:'',
           }});
  const{data:userConfigStatusData,isLoading:userConfigStatusDataISLoading,isSuccess:userConfigStatusDataIsSuccess} = Use_getUserConfigStatus({enable:true})     
  const {mutate:updateUser} = useUpdateUser();  
  
  const InputHandler =(key:any ,value:any)=>{
    setFormData((prev:any)=>({
       ...prev,
       [key]:value
    }))
  }

  // console.log('RolesData==============>',RolesData);
  const handleSubmit =(e:React.FormEvent<HTMLFormElement>)=>{
       e.preventDefault(); 

       const UserId:number  = rowData.UserId; 
       
       const ReqBody:ReqBodyInterfce={
        Name: formdata.name,
        Email: formdata.email,
        Phone: String(formdata.phone),
        RoleId: Number(formdata.Role),
        Status: Number(formdata.StatusValue) 
       }
       console.log("🚀 ~ handleSubmit ~ ReqBody:", ReqBody)
       updateUser({id:UserId,ReqBody:ReqBody})
       handleClose();
  }

  return (
    <form onSubmit={handleSubmit}>
      {/* First Input */}
      <label style={{ fontWeight: "500" }}>Name</label>
      <input
        value={formdata.name}
        onChange={(e:React.ChangeEvent<HTMLInputElement>)=>InputHandler('name',e.target.value)}
        type="text"
        className="form-control"
        placeholder="Enter name"
        style={{
          border: "2px solid #EDEDED",
          borderRadius: "8px",
          padding: "13px",
          fontSize: "14px",
          width: "100%",
        }}
      />
      <label style={{ fontWeight: "500" }}>Email</label>
      <input
        value={formdata.email}
        onChange={(e:React.ChangeEvent<HTMLInputElement>)=>InputHandler('email',e.target.value)}
        type="text"
        className="form-control"
        placeholder="Enter email"
        style={{
          border: "2px solid #EDEDED",
          borderRadius: "8px",
          padding: "13px",
          fontSize: "14px",
          width: "100%",
        }}
      />
      
      <label style={{ fontWeight: "500" }}>Phone</label>
      <input
        value={formdata.phone}
        onChange={(e:React.ChangeEvent<HTMLInputElement>)=>InputHandler('phone',e.target.value)}
        type="number"
        className="form-control"
        placeholder="Enter phone"
        style={{
          border: "2px solid #EDEDED",
          borderRadius: "8px",
          padding: "13px",
          fontSize: "14px",
          width: "100%",
        }}
      />
      

      <ReusableDropdown
        options={(!RolesIsLoading && rolesIssuccess && RolesData )||[]}
         value={formdata.Role}
        onChange={(value: any)=>InputHandler('Role',value) }
        DropdownHeading="Role"
      />
      <ReusableDropdown
        value={formdata.StatusValue}
        options={(!userConfigStatusDataISLoading && userConfigStatusDataIsSuccess && userConfigStatusData.formatedStatus) || []}
        onChange={(value: any) =>InputHandler('StatusValue',value)}
        DropdownHeading="Status"
      />

      {/* Buttons */}
      <div className="d-flex justify-content-start mt-3 gap-2">
        <Btn
          style={{ backgroundColor: "#43B9B2", color: "white" }}
          type="submit"
        >
          Submit
        </Btn>
        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
          }}
          type="button"
          onClick={handleClose}
        >
          Cancel
        </Btn>
      </div>
    </form>
  );
};

export default UserManagementModalContent;
